import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import Footer from "../../GenericComponents/Footer";
import EventHeader from "./LogHeader";
import LogList from "./LogList";
import GenericTableFilterBar from "../../GenericComponents/GenericTableFilterBar";
import { callApi, validateToken } from "../../../lib/utils";
import moment from "moment";
import { useSelector } from "react-redux";
import CustomLoader from "../../GenericComponents/CustomLoader";
import axios from "axios";
import store from "../../../reducers/store";
import "./EventLogPage.css";

const EventList = () => {
  const { eventType } = useParams();
  const [logData, setLogData] = useState([]);
  const [loading, setLoading] = useState(false);
  const pages = useSelector((state) => state?.appstate?.pages);
  const currentPage = useSelector((state) => state?.tableFilter?.currentPage);
  const perPage = useSelector((state) => state?.tableFilter?.perPage);
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);

  const setPagination = (data) => {
    store.dispatch({ type: "SET_PAGINATION_PAGES", payload: { pages: data } });
  };

  useEffect(() => {
    // Reset to first page when changing filters / route
    store.dispatch({
      type: "SET_CURRENT_PAGE",
      payload: { currentPage: 1 },
    });
  }, [eventType, startDate, endDate]);

  const fetchLogData = useCallback(() => {
    const limit = Number.parseInt(perPage, 10) || 20;
    const payload = {
      start: startDate,
      end: endDate,
      timezone: moment.tz.guess(),
      page: currentPage || 1,
      limit,
    };
    // 1. Set loader to true immediately to prevent "No Data" flash
    setLoading(true);

    validateToken((err) => {
      if (err) {
        // 2. Ensure loader is turned off if validation fails
        setLoading(false);
        window.location = "/logout";
        return;
      }

      // 3. Fetch data
      callApi(
        `/api/patient/dashboard/monitoring-events/${eventType}`,
        payload,
        "POST",
      )
        .then((response) => {
          const data = response?.data?.data;
          setLogData(
            data?.monitoringEventLogs ??
              data?.monitoringEvents ??
              data?.monitoringEventsList ??
              data ??
              [],
          );
          const totalPages =
            data?.pagination?.pages ??
            data?.pagination?.totalPages ??
            data?.pages;
          if (Number.isFinite(totalPages)) {
            setPagination(totalPages);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log("err: ", err);
          setLoading(false);
        });
    });
  }, [currentPage, endDate, eventType, perPage, startDate]);

  const exportFiles = (type) => {
    let params = {
      start: startDate,
      end: endDate,
      timezone: moment.tz.guess(),
    };
    setLoading(true);

    axios({
      method: "post",
      url: `/api/export/monitoring-events/${eventType}`,
      responseType: "blob",
      data: params,
    })
      .then((response) => {
        var filename = "";
        let disposition = null;

        if (Object.keys(response.headers).includes("content-disposition")) {
          disposition = response.headers["content-disposition"];
        } else if (
          Object.keys(response.headers).includes("Content-Disposition")
        ) {
          disposition = response.headers["Content-Disposition"];
        }

        // var disposition = xhr.getResponseHeader('Content-Disposition');
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        let blobData = response.data;
        setLoading(false);
        fileDownload(filename, blobData);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const fileDownload = (filename, blobData) => {
    var blobURL = window.URL.createObjectURL(blobData);
    var tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute(
      "download",
      filename !== "" ? `${filename}` : "report.pdf",
    );

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  };

  useEffect(() => {
    fetchLogData();
  }, [fetchLogData]);
  return (
    <div className="event-log-page">
      <div className="event-log-page__content">
        <EventHeader eventType={eventType} />
        <CustomLoader loading={loading} />
        <GenericTableFilterBar
          pages={pages}
          showPdfExportIcon={
            logData.length > 0  ? true : false
          }
          pdfExport={() => exportFiles("pdf")}
          isSearchVisible={false}
        />
        <LogList
          eventType={eventType}
          hrmEventsList={logData}
          currentPage={currentPage || 1}
          perPage={perPage}
          loading={loading}
        />
      </div>
      <Footer />
    </div>
  );
};

export default EventList;
